module.exports = __webpack_public_path__ + "img/6-1.09a2a438.png";